import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import moment from 'moment';

import Tag from '../../../../components/V2/Tag';
import OrderDetails from './OrderDetails';
import { PRODUCT_TEMP } from 'core/assets/images/V2';
import { Text, Box, Button, Link, Flex, Image } from 'core/ui/atoms';

const OrderHistoryItem = ({ order }) => {
  const { id, dummy, date, status, trackingUrl, image } = order || {};
  const [openModal, setOpenModal] = useState(false);

  const closeModal = () => setOpenModal(false);
  const orderName = 'Signature Program';
  const productImage = image?.smallUrl || PRODUCT_TEMP;

  return (
    <ProductContainer>
      <ItemContainer direction='row' justifyContent='start'>
        <SelectCont>
          <ProductImage src={productImage} alt={id} />
        </SelectCont>
        <DetailsContainer>
          <ProductName>{orderName}</ProductName>
          <Flex direction='row' justifyContent='space-between' alignItems='center'>
            <SubTitle>{moment(date).format('MMM DD, YYYY')}</SubTitle>
            <Tag text={status} style={dummy ? 'outline' : 'default'} />
          </Flex>
          <ViewDetailsContainer direction='row' justifyContent='space-between'>
            <DetailButton onClick={() => setOpenModal(true)}>VIEW DETAILS</DetailButton>
            {trackingUrl &&
              <ButtonLink href={trackingUrl} target='_blank'>TRACK ORDER</ButtonLink>
            }
          </ViewDetailsContainer>
        </DetailsContainer>
      </ItemContainer>
      {openModal &&
        <OrderDetails
          closeModal={closeModal}
          order={order}
        />
      }
    </ProductContainer>
  );
};

OrderHistoryItem.propTypes = {
  order: PropTypes.object.isRequired,
};

const ItemContainer = styled(Flex)`
  width: 33%;
  ${(p) => p.theme.max('sm')`
    width: 100%;
  `}
`;

const ViewDetailsContainer = styled(Flex)`
  margin-top: 20px;
`;

const ButtonLink = styled(Link)`
  text-transform: uppercase;
  text-decoration: underline;
  text-underline-offset: 5px;
  padding: 0;
  margin: 0;
  color: ${(p) => p.theme.colors.primaryV2};
  text-align: center;
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1.2px;
  text-transform: uppercase;
`;

const DetailButton = styled(Button)`
  text-transform: uppercase;
  text-decoration: underline;
  text-underline-offset: 5px;
  padding: 0;
  margin: 0;
  color: ${(p) => p.theme.colors.primaryV2};
  text-align: center;
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1.2px;
  text-transform: uppercase;
`;

const SubTitle = styled(Text)`
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-size: 12px;
  line-height: 22px;
  margin: 0px;
  color: ${(p) => p.theme.colors.primaryV2};
`;

const ProductImage = styled(Image)`
  height: 94px;
  width: 94px;
  object-fit: cover;
`;

const SelectCont = styled.div`
  position: relative;
  width: 28%;
  display: flex;
  justify-content: end;
  flex-shrink: 0;
  margin-right: 10px;
  &:last-child {
    margin-right: 0;
  }
`;

const ProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 44px;
`;

const DetailsContainer = styled(Box)`
  width: 60%;
`;

const ProductName = styled.p`
  font-family: ${({ theme }) => theme.typography.familyLarken};
  font-size: 16px;
  line-height: 22px;
  margin: 0px;
  color: ${(p) => p.theme.colors.primaryV2};
`;

export default OrderHistoryItem;
